<template>
    <div class="left-aside">
        <div style="padding :10px;display: flex;align-items: center;gap: 10px;box-sizing: border-box;flex-wrap: wrap;">
            <div style="display: flex;width: 100%;">
                <el-input v-model="filterParms.search_word" clearable
                    placeholder="Search email by email subject or email address" style="width: 400px;"></el-input>
                <el-button type="info" style="margin-left: 20px;" size="small" @click="doSearchEmail">Seach
                    Emails</el-button>
                <el-button type="danger" style="margin-left: 20px;" size="small"
                    @click="refreshEmail">Refresh</el-button>
            </div>

            <el-select v-if="type == 'in'" style="width: 300px;" v-model="filterParms.assigned_user_id"
                :clearable="true" placeholder="Please select assigned user">
                <el-option v-for="(assigned_user, index) in operators" :key="index" :value="assigned_user._id.$id"
                    :label="(assigned_user?.user_lastName + ' ' + assigned_user?.user_givenName)"></el-option>
            </el-select>
            <el-select v-if="type == 'out'" style="width: 300px;" v-model="filterParms.sender_id" :clearable="true"
                placeholder="Please select operator">
                <el-option v-for="(sender, index) in operators" :key="index" :value="sender._id.$id"
                    :label="(sender?.user_lastName + ' ' + sender?.user_givenName)"></el-option>
            </el-select>
            <el-select v-model="filterParms.email_address" style="width: 300px;" :clearable="true"
                :placeholder="type == 'in' ? 'Please select receiver email' : 'Please select sender email'">
                <el-option v-for="(email, index) in companyEmails" :key="index" :value="email.email_address"
                    :label="email.email_address"></el-option>
            </el-select>
            <div v-if="type == 'in'" style="display: flex;align-items: center;">
                <p style="font-weight: bold;font-size: 14px;color: #4a8af4"> Reply Status </p>
                <el-radio-group style="margin-left: 15px;margin-top: 5px;" v-model="filterParms.reply_status"
                    @change="handleReplyStatusChanged">
                    <el-radio label="all">All</el-radio>
                    <el-radio label="pending" style="margin-left: 10px;">Pending Reply</el-radio>
                </el-radio-group>
            </div>
            <el-button type="primary" size="small" @click="doSubmitRequestData('reset')">Request Data</el-button>
            <el-button type="success" size="small" @click="requestPrePage">Pre Page</el-button>
            <el-button type="success" size="small" @click="requestNextPage">Next Page</el-button>
            <p>第{{ page + 1 }}页</p>
        </div>
        <div style="flex: 1;height: 100%;overflow-y: auto;" ref="emailContainer">
            <div v-for="(item, index) in showDataList" :key="index"
                :class="selectMailIndex == index ? 'nav-item nav-item-selected' : 'nav-item'"
                @click="handleSelectMail(item, index)">
                <div style="text-align: right;">
                          <el-dropdown>
                                <i class="el-icon-more"></i>
                                <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>
                                    <div @click.stop="doDeleteEmail(item)">删除邮件</div>
                                </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                </div>
                <div style="text-align: left;margin-bottom: 0px;margin-right: 10px;" v-if="type == 'in'">
                    <p class="reply" :style="createReplyStatusStyle(item)">
                        {{ formatReplyStatus(item) }} </p>
                </div>
                <div style="text-align: left;margin-bottom: 0px;margin-right: 10px;" v-if="type == 'out'">
                    <p v-if="item.send_result == 'success'" class="reply"
                        :style="{ color: item.open_status && item.open_status == true ? '#409EFF' : '#E6A23C' }">
                        {{ item.open_status && item.open_status == true ? 'Opened' : 'Not Open' }}
                    </p>
                    <p v-else class="reply" :style="{ color: '#F56C6C' }">
                        {{ 'Failured' }}
                    </p>
                </div>

                <p class="email">{{ formatMailDate(item) }} | <span class="sender-role" :class="'role-' + (senderRoles[item.from] || 'Unknown').toLowerCase()" v-if="senderRoles[item.from]">{{ senderRoles[item.from] }}</span>{{ item.fromName }} ({{ item.from }}) TO: {{ item.to }}
                </p>
                <p class="time" v-if="type == 'out'" style="margin-top: 5px;">By {{ item.sender?.user_lastName + " " +
                    item.sender?.user_givenName }}</p>
                <p class="subject">{{ item.subject }} <span style="font-size: 12px;color: #bbb;font-weight: normal;">{{
                    item.content_plain && item.content_plain != '' && item.content_plain.length > 150 ?
                        item.content_plain.substring(0, 150) + '...' : item.content_plain }}</span></p>

                <p class="time"></p>
                <p class="email"></p>
                <div v-if="item.assigned_user_id">
                    <p class="email" style="margin-top: 5px;color:blue" v-if="item.assigned_user_id != -1">Assigned to :
                        {{
                            item.assigned_user?.user_lastName + " " +
                            item.assigned_user?.user_givenName }} <span
                            style="font-size: 12px;color: red;font-weight: normal;">({{ item.reply_instruction
                            }})</span></p>
                    <p class="email" style="margin-top: 5px;color:blue" v-else>Not Assigned</p>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import {
    removeMail,
    getCompanyEmailsV1,
    batchGetEmailSenderRoles
} from '../../api/assistant'
import {
    formatDate
} from '../../utils/date'
export default ({
    name: 'index',
    props: {
        page: {
            type: Number,
            default: 0
        },
        operators: {
            type: Array,
            default: []
        },
        type: {
            type: String,
            default: ''
        },
        emails: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            filterParms: {
                assigned_user_id: '',
                email_address: '',
                sender_id: '',
                reply_status: '',
                search_word: ''
            },
            selectAssignedUser: '',//收件箱
            selectSender: '',//发件箱
            selectReplyStatus: 'all',//收件箱
            filterEmail: '',//发，收都用
            filterEmails: [],
            dataList: [],
            showDataList: [],
            companyEmails: [],
            senderRoles: {},
            selectMailIndex: -1,
            currentUser: {
                user_lastName: '',
                user_givenName: '',
                user_enName: ''
            },
            isLoading: false,
            error: null
        }
    },
    watch: {
        emails: {
            handler(newVal, oldVal) {
                this.handleEmailsData(newVal)
            },
            immediate: true
        },
    },
    mounted() {
        this.requestCompanyEmails()
    },
    methods: {

        doDeleteEmail(email){
            this.$confirm(
                "Are you sure you want to delete this email?",
                "Delete Email",
                {
                type: "warning",
                cancelButtonText: "Cancel",
                confirmButtonText: "Confirm",
                }
            ).then(() => {
                removeMail(email._id.$id).then((res) => {
                this.$message.success("Delete success!");
                this.$emit("emailDeleted");
                });
            });
        },

        refreshEmail() {
            this.filterParms.search_word = ''
            let data = {
                page: "init",
                params: ''
            }
            this.$emit('handleFilterEmailRequest', data)
        },

        requestNextPage() {
            this.doSubmitRequestData('next_page')
        },
        requestPrePage() {
            this.doSubmitRequestData('pre_page')
        },

        doSearchEmail() {
            if (this.filterParms.search_word && this.filterParms.search_word != '') {
                let data = {
                    page: "search",
                    params: this.filterParms.search_word
                }
                this.$emit('handleFilterEmailRequest', data)
            }
        },

        doSubmitRequestData(request_type) {
            let new_params = {}
            if (this.filterParms.assigned_user_id && this.filterParms.assigned_user_id != '') {
                new_params.assigned_user_id = this.filterParms.assigned_user_id
            }
            if (this.filterParms.email_address && this.filterParms.email_address != '') {
                if (this.type == 'in') {
                    new_params.to = this.filterParms.email_address
                } else {
                    new_params.from = this.filterParms.email_address
                }
            }
            if (this.filterParms.sender_id && this.filterParms.sender_id != '') {
                new_params.sender_id = this.filterParms.sender_id
            }
            if (this.filterParms.reply_status == 'pending') {
                new_params.reply_status = 'pending'
            }
            let data = {
                page: request_type,
                params: new_params
            }
            this.$emit('handleFilterEmailRequest', data)
        },

        refreshSingleMail(mail) {
            for (let i = 0; i < this.dataList.length; i++) {
                if (this.dataList[i]._id.$id == mail._id.$id) {
                    this.dataList[i] = mail
                    break
                }
            }
            for (let i = 0; i < this.showDataList.length; i++) {
                if (this.showDataList[i]._id.$id == mail._id.$id) {
                    this.showDataList[i] = mail
                    break
                }
            }
            this.$nextTick(() => {
                this.$forceUpdate()
            })
        },

        resetSelectMailIndex() {
            this.selectMailIndex = -1
        },
        //收件箱使用
        handleReplyStatusChanged(e) {
            this.doSubmitRequestData('reset')
        },

        formatReplyStatus(mail) {
            if (mail.reply_status) {
                if (mail.reply_status == -1 ) {
                    return 'No Need to Reply'
                }
                if (mail.reply_status > 0) {
                    return 'Replied'
                }
            }
            return 'Pending Reply'
        },

        createReplyStatusStyle(mail) {
            let style = { //默认是没有的，需要回复
                color: "red"
            }
            if (mail.reply_status) {//有
                if (mail.reply_status == -1) {
                    style.color = '#666'
                }
                if (mail.reply_status > 0) {
                    style.color = 'green'
                }
            }
            return style
        },

        async requestCompanyEmails() {
            this.isLoading = true
            this.error = null
            try {
                const response = await getCompanyEmailsV1()
                this.companyEmails = response.data
            } catch (error) {
                console.error('Error fetching company emails:', error)
                this.error = error.message
                this.$message.error('获取公司邮件列表失败')
            } finally {
                this.isLoading = false
            }
        },

        handleEmailsData() {
            this.filterEmail = ''
            this.dataList = []
            this.showDataList = []
            if (this.emails && this.emails.length > 0) {
                this.emails.map((item) => {
                    this.dataList.push(item)
                    this.showDataList.push(item)
                })
                this.fetchSenderRoles()
            }
            if (this.$refs.emailContainer) {
                this.$refs.emailContainer.scrollTo({
                    top: 0,
                    behavior: "smooth"
                })
            }
        },

        async fetchSenderRoles() {
            // 收集未查询过的唯一发件人邮箱
            let uniqueEmails = [...new Set(this.showDataList.map(item => item.from))]
            let newEmails = uniqueEmails.filter(email => !this.senderRoles[email])
            if (newEmails.length === 0) return
            try {
                let res = await batchGetEmailSenderRoles(newEmails)
                if (res.data) {
                    this.senderRoles = { ...this.senderRoles, ...res.data }
                    this.$forceUpdate()
                }
            } catch (e) {
                console.error('Failed to fetch sender roles:', e)
            }
        },

        formatMailDate(mail) {
            const create_time = mail.create_time
            const date = new Date(create_time * 1000)
            const utc = date.getTime() + date.getTimezoneOffset() * 60000
            const nd = new Date(utc + 8 * 60 * 60 * 1000)
            return formatDate(nd, 'yyyy-MM-dd hh:mm:ss')
        },
        handleSelectMail(email, index) {
            this.selectMailIndex = index
            if (this.type == 'in') {
                this.$emit('handleInSelectMail', email)
            } else {
                this.$emit('handleOutSelectMail', email)
            }
        }
    }
})
</script>
<style scoped lang="scss">
.left-aside {
    height: calc(100vh - 60px);
    display: flex;
    background-color: white;
    flex-direction: column;
    border-left: 1px solid #f5f5f5;
    box-sizing: border-box;

    .nav-item {
        cursor: pointer;
        padding: 10px 15px;
        box-sizing: border-box;
        width: 100%;
        color: #333;
        font-size: 16px;
        background-color: white;
        border-bottom: 1px solid #f5f5f5;

        .sender-role {
            display: inline-block;
            margin: 0px;
            margin-right: 5px;
            font-size: 10px;
            font-weight: bold;
            padding: 1px 6px;
            border-radius: 3px;
            vertical-align: middle;
        }
        .role-advisor {
            background-color: #E6A23C;
            color: white;
        }
        .role-student {
            background-color: #409EFF;
            color: white;
        }
        .role-unknown {
            background-color: #909399;
            color: white;
        }

        .reply {
            display: inline-block;
            margin: 0px;
            font-size: 10px;
            color: red;
        }


        .email {
            font-size: 12px;
            color: #666;

            margin: 0px;
        }

        .time {
            margin-top: 5px;
            margin-bottom: 5px;
            color: #666;
            font-size: 12px;
        }

        .subject {
            margin: 5px 0px;
            color: #333;
            font-size: 12px;
            font-weight: bold;
        }

        &:hover {
            background-color: #f5f5f5;
        }
    }

    .nav-item-selected {
        background-color: #FFD9D4;

        &:hover {
            background-color: #FFD9D4;
        }
    }

    .nav-item:last-child {
        margin-bottom: 40px;
    }
}
</style>
